import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor() { }
  loadScript(appSelectorName: string) {
    //var isFound = false;
    var scripts = document.getElementsByTagName("script");
    // for (var i = 0; i < scripts.length; ++i) {
    //   if (scripts[i].getAttribute('id') === `${appSelectorName}-app`) {
    //     isFound = true;
    //     return;
    //   }
    // }
    var s = Array.from(scripts);
    var isFound = s.find(item => item.getAttribute('id') === `${appSelectorName}-app`);
    if (!isFound) {
      var dynamicScripts = [`/assets/${appSelectorName}-app.js`];
      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.id = `${appSelectorName}-app`;
        node.type = 'text/javascript';
        node.async = false;
        document.getElementsByTagName('body')[0].appendChild(node);
      }
    }
  }
}